import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { Button, TextInput } from '@tremor/react';
import './App.css';
import { genSaltSync, hashSync } from 'bcrypt-ts';
import { useApiV1SignupPasswordCreate } from 'api/api.gen';
import { useSearchParams } from 'react-router-dom';
import clsx from 'clsx';
import { LockIcon } from 'icons/lockIcon';
import { setAuthHeader } from 'api/ApiConfig';

dayjs.extend(utc);

export default function PasswordApp() {
    const [password, setPassword] = useState('');
    const [confirm, setConfirm] = useState('');
    const [locationSearchParams] = useSearchParams();
    const ticket = locationSearchParams.get('ticket');
    const {
        isExecuted,
        isLoading,
        sendNowWithParams: changePass,
    } = useApiV1SignupPasswordCreate({}, {}, false);
    useEffect(() => {
        if (isExecuted && !isLoading) {
            setAuthHeader('');
            localStorage.clear();
            window.location.href = '/';
        }
    }, [isLoading, isExecuted]);

    const submitPasswordChange = () => {
        if (password !== confirm) {
            return;
        }

        const salt = genSaltSync(10);
        const hash = hashSync(password, salt);

        changePass(
            {
                password_hash: hash,
                token: ticket || '',
            },
            {}
        );
    };

    return (
        <div className="flex min-h-screen flex-1 text-primary-content flex-col justify-center bg-base-100 py-12 sm:px-6 md:px-8">
            <div className="sm:mx-auto sm:w-full sm:max-w-[480px]">
                <div className="flex flex-col gap-12 bg-base-200  px-6 py-12 sm:rounded-lg sm:px-6">
                    <div className="sm:mx-auto sm:w-full sm:max-w-lg">
                        <h2 className="text-2xl font-medium leading-9 tracking-tight text-primary-content ">
                            Welcome to Reqter
                        </h2>
                        <p className="mt-1 text-sm leading-6 text-gray-500">
                            Change your password
                        </p>
                    </div>
                    <div className="flex flex-col gap-8">
                        <div className="flex flex-col gap-6">
                            <TextInput
                                icon={LockIcon}
                                tabIndex={-2}
                                required
                                type="password"
                                placeholder="Password"
                                className="w-full pe-10 py-1 text-primary-content border border-border dark:border-border-dark  rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                value={password}
                                onValueChange={setPassword}
                            />
                            <TextInput
                                icon={LockIcon}
                                tabIndex={-2}
                                required
                                type="password"
                                placeholder="Confirm Password"
                                className="w-full pe-10 py-1 border border-border dark:border-border-dark  rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                value={confirm}
                                onValueChange={setConfirm}
                                error={password !== confirm}
                                errorMessage="Password and confirm must be equal"
                            />
                        </div>

                        <Button
                            tabIndex={-3}
                            id="submit-login"
                            type="submit"
                            loading={!!isExecuted && !!isLoading}
                            onClick={submitPasswordChange}
                            className={clsx(
                                'flex w-full text-white justify-center bg-neutral4 rounded-md px-3 py-3 text-sm font-semibold leading-6  shadow-sm hover:bg-secondary-content',
                                password === confirm && password.length > 0
                                    ? 'bg-black'
                                    : 'bg-secondary-content hover:bg-neutral4'
                            )}
                            disabled={
                                password !== confirm || password.length === 0
                            }
                        >
                            Change password
                        </Button>
                    </div>
                    <p className="text-center text-sm">
                        By creating an account, you agree to our Terms of
                        Service and Privacy Policy, and accept our Cookie
                        Policy.
                    </p>
                </div>
            </div>
        </div>
    );
}
